import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Wall } from 'types';

export const getWall = async (wallId: number): Promise<Wall | undefined> => {
  if (wallId < 1) return;
  const { data } = await axios.get(`/api/walls/${wallId}`);
  return data as Wall;
};

type QueryFnType = typeof getWall;

type UseWallOptions = {
  wallId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useWall = ({ wallId, config }: UseWallOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['wall', wallId],
    queryFn: () => getWall(wallId),
  });
};
